export default {
  nav: {
    logo: '',
    links: [
      // { text: 'Project', to: 'projects' },
      // { text: 'About-Me', to: "aboutMe"},
      { text: 'Contact', to: 'contact' },
    ],
  },
  header: {
    text: ['Hi!', "It's me Osman Faruk",],
    typical: [
      "Dino The Future Friend",
      5000,
      'Junior programmer',
      10000
    ],
  },
  work: 
    {
      title: 'Projects',
      img: process.env.PUBLIC_URL + '/assets/project-mobile.png',
    },
 
  stack: {
    title: 'Stack',
    tech: [
      {
        img: process.env.PUBLIC_URL + '/assets/mongo.png',
        alt: 'mongodb',
      },
      {
        img: process.env.PUBLIC_URL + '/assets/react.png',
        alt: 'react',
      },
      {
        img: process.env.PUBLIC_URL + '/assets/express.png',
        alt: 'express',
      },
      {
        img: process.env.PUBLIC_URL + '/assets/node.png',
        alt: 'node',
      },
    ],
  },
};
